import { useProjectSettings } from '@api/settings';
import Loader from '@components/Loader/Loader';
import { Box } from '@mui/system';
import React, { FC } from 'react';
import HomeAnalytics from './HomeAnalytics';
import HomeAnalyticsEmpty from './HomeAnalyticsEmpty';

const HomeAnalyticsLayout: FC = () => {
	const { data, isLoading } = useProjectSettings();

	return (
		<Box display="flex" flexGrow={1} flexDirection="column" px={1}>
			<Loader isLoading={isLoading}>
				{!data || data?.hasNoActivity ? (
					<HomeAnalyticsEmpty />
				) : (
					<HomeAnalytics />
				)}
			</Loader>
		</Box>
	);
};

export default HomeAnalyticsLayout;
